import {
  ActivityConfiguration,
  AddConfigDTO,
  Config_Socket_DTO,
  Delete_Socket_DTO,
  ResidentActivityType,
  SendActivityDTO,
  skipActivityDTO,
} from ".";
import { ReminderAction } from "../alerts";

export enum DAILY_PLAN {
  ADD_PLAN_CONFIG_REQUEST = "DAILY_PLAN.ADD_PLAN_CONFIG_REQUEST",
  ADD_PLAN_CONFIG_SUCCESS = "DAILY_PLAN.ADD_PLAN_CONFIG_SUCCESS",
  ADD_PLAN_CONFIG_FAILURE = "DAILY_PLAN.ADD_PLAN_CONFIG_FAILURE",

  EDIT_PLAN_CONFIG_REQUEST = "DAILY_PLAN.EDIT_PLAN_CONFIG_REQUEST",
  EDIT_PLAN_CONFIG_SUCCESS = "DAILY_PLAN.EDIT_PLAN_CONFIG_SUCCESS",
  EDIT_PLAN_CONFIG_FAILURE = "DAILY_PLAN.EDIT_PLAN_CONFIG_FAILURE",

  DELETE_PLAN_CONFIG_REQUEST = "DAILY_PLAN.DELETE_PLAN_CONFIG_REQUEST",
  DELETE_PLAN_CONFIG_SUCCESS = "DAILY_PLAN.DELETE_PLAN_CONFIG_SUCCESS",
  DELETE_PLAN_CONFIG_FAILURE = "DAILY_PLAN.DELETE_PLAN_CONFIG_FAILURE",

  GET_RESIDENTS_ACTIVITIES_CONFIGURATION_REQUEST = "DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_REQUEST",
  GET_RESIDENTS_ACTIVITIES_CONFIGURATION_SUCCESS = "DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_SUCCESS",
  GET_RESIDENTS_ACTIVITIES_CONFIGURATION_FAILURE = "DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_FAILURE",

  GET_RESIDENTS_ACTIVITIES_REQUEST = "DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_REQUEST",
  GET_RESIDENTS_ACTIVITIES_SUCCESS = "DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_SUCCESS",
  GET_RESIDENTS_ACTIVITIES_FAILURE = "DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_FAILURE",

  GET_ONE_RESIDENT_ACTIVITIES_REQUEST = "DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_REQUEST",
  GET_ONE_RESIDENT_ACTIVITIES_SUCCESS = "DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_SUCCESS",
  GET_ONE_RESIDENT_ACTIVITIES_FAILURE = "DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_FAILURE",

  SEND_RESIDENT_ACTIVITY_REQUEST = "DAILY_PLAN.SEND_RESIDENT_ACTIVITY_REQUEST",
  SEND_RESIDENT_ACTIVITY_SUCCESS = "DAILY_PLAN.SEND_RESIDENT_ACTIVITY_SUCCESS",
  SEND_RESIDENT_ACTIVITY_FAILURE = "DAILY_PLAN.SEND_RESIDENT_ACTIVITY_FAILURE",

  SKIP_ACTIVITY_REQUEST = "DAILY_PLAN.SKIP_ACTIVITY_REQUEST",
  SKIP_ACTIVITY_SUCCESS = "DAILY_PLAN.SKIP_ACTIVITY_SUCCESS",
  SKIP_ACTIVITY_FAILURE = "DAILY_PLAN.SKIP_ACTIVITY_FAILURE",

  UNSKIP_ACTIVITY_REQUEST = "DAILY_PLAN.UNSKIP_ACTIVITY_REQUEST",
  UNSKIP_ACTIVITY_SUCCESS = "DAILY_PLAN.UNSKIP_ACTIVITY_SUCCESS",
  UNSKIP_ACTIVITY_FAILURE = "DAILY_PLAN.UNSKIP_ACTIVITY_FAILURE",

  GET_ACTIVITY_BY_SOCKET = "DAILY_PLAN.GET_ACTIVITY_BY_SOCKET",

  GET_ACTIVITY_CONFIG_ADDED_BY_SOCKET = "DAILY_PLAN.GET_ACTIVITY_CONFIG_ADDED_BY_SOCKET",
  GET_ACTIVITY_CONFIG_DELETED_BY_SOCKET = "DAILY_PLAN.GET_ACTIVITY_CONFIG_DELETED_BY_SOCKET",
  GET_ACTIVITY_CONFIG_UPDATED_BY_SOCKET = "DAILY_PLAN.GET_ACTIVITY_CONFIG_UPDATED_BY_SOCKET",

  GET_ACTIVITIES_FEEDBACK_OPTIONS_REQUEST = "DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_REQUEST",
  GET_ACTIVITIES_FEEDBACK_OPTIONS_SUCCESS = "DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_SUCCESS",
  GET_ACTIVITIES_FEEDBACK_OPTIONS_FAILURE = "DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_FAILURE",

  GET_ACTIVITIES_SKIP_OPTIONS_REQUEST = "DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_REQUEST",
  GET_ACTIVITIES_SKIP_OPTIONS_SUCCESS = "DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_SUCCESS",
  GET_ACTIVITIES_SKIP_OPTIONS_FAILURE = "DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_FAILURE",

  BULK_DELETE_PLAN_CONFIG_REQUEST = "DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_REQUEST",
  BULK_DELETE_PLAN_CONFIG_SUCCESS = "DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_SUCCESS",
  BULK_DELETE_PLAN_CONFIG_FAILURE = "DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_FAILURE",

  BULK_ADD_PLAN_CONFIG_REQUEST = "DAILY_PLAN.BULK_ADD_PLAN_CONFIG_REQUEST",
  BULK_ADD_PLAN_CONFIG_SUCCESS = "DAILY_PLAN.BULK_ADD_PLAN_CONFIG_SUCCESS",
  BULK_ADD_PLAN_CONFIG_FAILURE = "DAILY_PLAN.BULK_ADD_PLAN_CONFIG_FAILURE",

  GET_RESIDENTS_PRESENCES_REQUEST = "DAILY_PLAN.GET_RESIDENTS_PRESENCES_REQUEST",
  GET_RESIDENTS_PRESENCES_SUCCESS = "DAILY_PLAN.GET_RESIDENTS_PRESENCES_SUCCESS",
  GET_RESIDENTS_PRESENCES_FAILURE = "DAILY_PLAN.GET_RESIDENTS_PRESENCES_FAILURE",

  GET_ONE_RESIDENT_PRESENCES_REQUEST = "DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_REQUEST",
  GET_ONE_RESIDENT_PRESENCES_SUCCESS = "DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_SUCCESS",
  GET_ONE_RESIDENT_PRESENCES_FAILURE = "DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_FAILURE",
}

export interface IAddPlanConfigRequest {
  type: typeof DAILY_PLAN.ADD_PLAN_CONFIG_REQUEST;
  payload: {
    residentId: string;
    item: ActivityConfiguration;
  };
}
export interface IAddPlanConfigSuccess {
  type: typeof DAILY_PLAN.ADD_PLAN_CONFIG_SUCCESS;
  payload: {
    residentId: string;
    item: ActivityConfiguration;
  };
}
export interface IAddPlanConfigFailure {
  type: typeof DAILY_PLAN.ADD_PLAN_CONFIG_FAILURE;
  payload: any;
}

export interface IEditPlanConfigRequest {
  type: typeof DAILY_PLAN.EDIT_PLAN_CONFIG_REQUEST;
  payload: {
    residentId: string;
    item: ActivityConfiguration;
  };
}
export interface IEditPlanConfigSuccess {
  type: typeof DAILY_PLAN.EDIT_PLAN_CONFIG_SUCCESS;
  payload: {
    residentId: string;
    item: ActivityConfiguration;
  };
}
export interface IEditPlanConfigFailure {
  type: typeof DAILY_PLAN.EDIT_PLAN_CONFIG_FAILURE;
  payload: any;
}

export interface IDeletePlanConfigRequest {
  type: typeof DAILY_PLAN.DELETE_PLAN_CONFIG_REQUEST;
  payload: {
    residentId: string;
    itemType: ResidentActivityType;
  };
}
export interface IDeletePlanConfigSuccess {
  type: typeof DAILY_PLAN.DELETE_PLAN_CONFIG_SUCCESS;
  payload: {
    residentId: string;
    itemType: ResidentActivityType;
  };
}
export interface IDeletePlanConfigFailure {
  type: typeof DAILY_PLAN.DELETE_PLAN_CONFIG_FAILURE;
  payload: any;
}

export interface IGetResidentsConfigurationRequest {
  type: typeof DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_REQUEST;
}
export interface IGetResidentsConfigurationSuccess {
  type: typeof DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_SUCCESS;
  payload: any[];
}
export interface IGetResidentsConfigurationFailure {
  type: typeof DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_FAILURE;
  payload: any;
}

export interface IGetResidentsActivitiesRequest {
  type: typeof DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_REQUEST;
  payload: {
    startDate: string;
    endDate: string;
  };
}
export interface IGetResidentsActivitiesSuccess {
  type: typeof DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_SUCCESS;
  payload: {
    startDate: string;
    endDate: string;
    data: any[];
  };
}
export interface IGetResidentsActivitiesFailure {
  type: typeof DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_FAILURE;
  payload: any;
}

export interface IGetResidentActivitiesRequest {
  type: typeof DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_REQUEST;
  payload: {
    startDate: string;
    endDate: string;
    residentId: string;
  };
}
export interface IGetResidentActivitiesSuccess {
  type: typeof DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_SUCCESS;
  payload: {
    startDate: string;
    endDate: string;
    residentId: string;
    data: any[];
  };
}
export interface IGetResidentActivitiesFailure {
  type: typeof DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_FAILURE;
  payload: any;
}

export interface ISendResidentActivityRequest {
  type: typeof DAILY_PLAN.SEND_RESIDENT_ACTIVITY_REQUEST;
  payload: SendActivityDTO;
}
export interface ISendResidentActivitySuccess {
  type: typeof DAILY_PLAN.SEND_RESIDENT_ACTIVITY_SUCCESS;
  payload: SendActivityDTO;
}
export interface ISendResidentActivityFailure {
  type: typeof DAILY_PLAN.SEND_RESIDENT_ACTIVITY_FAILURE;
  payload: any;
}

export interface ISkipActivityRequest {
  type: typeof DAILY_PLAN.SKIP_ACTIVITY_REQUEST;
  payload: skipActivityDTO;
}
export interface ISkipActivitySuccess {
  type: typeof DAILY_PLAN.SKIP_ACTIVITY_SUCCESS;
  payload: any;
}
export interface ISkipActivityFailure {
  type: typeof DAILY_PLAN.SKIP_ACTIVITY_FAILURE;
  payload: any;
}

export interface IUnSkipActivityRequest {
  type: typeof DAILY_PLAN.UNSKIP_ACTIVITY_REQUEST;
  payload: skipActivityDTO;
}
export interface IUnSkipActivitySuccess {
  type: typeof DAILY_PLAN.UNSKIP_ACTIVITY_SUCCESS;
  payload: any;
}
export interface IUnSkipActivityFailure {
  type: typeof DAILY_PLAN.UNSKIP_ACTIVITY_FAILURE;
  payload: any;
}

export interface IGetActivityBySocket {
  type: typeof DAILY_PLAN.GET_ACTIVITY_BY_SOCKET;
  payload: ReminderAction;
}
export interface IGetCongigAddedBySocket {
  type: typeof DAILY_PLAN.GET_ACTIVITY_CONFIG_ADDED_BY_SOCKET;
  payload: Config_Socket_DTO;
}

export interface IGetCongigDeletedBySocket {
  type: typeof DAILY_PLAN.GET_ACTIVITY_CONFIG_DELETED_BY_SOCKET;
  payload: Delete_Socket_DTO;
}

export interface IGetCongigUpdatedBySocket {
  type: typeof DAILY_PLAN.GET_ACTIVITY_CONFIG_UPDATED_BY_SOCKET;
  payload: Config_Socket_DTO;
}

export interface IGetActivitiesFeedbackOptionsRequest {
  type: typeof DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_REQUEST;
}
export interface IGetActivitiesFeedbackOptionsSuccess {
  type: typeof DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_SUCCESS;
  payload: any;
}
export interface IGetActivitiesFeedbackOptionsFailure {
  type: typeof DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_FAILURE;
  payload: any;
}

export interface IGetActivitiesSkipOptionsRequest {
  type: typeof DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_REQUEST;
}
export interface IGetActivitiesSkipOptionsSuccess {
  type: typeof DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_SUCCESS;
  payload: any;
}
export interface IGetActivitiesSkipOptionsFailure {
  type: typeof DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_FAILURE;
  payload: any;
}
export interface IDeleteBulkPlanConfigRequest {
  type: typeof DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_REQUEST;
  payload: {
    residentIds: string[];
    activityType: ResidentActivityType;
  };
}
export interface IDeleteBulkPlanConfigSuccess {
  type: typeof DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_SUCCESS;
  payload: {
    residentIds: string[];
    activityType: ResidentActivityType;
  };
}
export interface IDeleteBulkPlanConfigFailure {
  type: typeof DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_FAILURE;
  payload: any;
}

export interface IAddBulkPlanConfigRequest {
  type: typeof DAILY_PLAN.BULK_ADD_PLAN_CONFIG_REQUEST;
  payload: AddConfigDTO;
}
export interface IAddBulkPlanConfigSuccess {
  type: typeof DAILY_PLAN.BULK_ADD_PLAN_CONFIG_SUCCESS;
  payload: AddConfigDTO;
}
export interface IAddBulkPlanConfigFailure {
  type: typeof DAILY_PLAN.BULK_ADD_PLAN_CONFIG_FAILURE;
  payload: any;
}

export interface IGetResidentsPresencesRequest {
  type: typeof DAILY_PLAN.GET_RESIDENTS_PRESENCES_REQUEST;
  payload: {
    startDate: string;
    endDate: string;
  };
}
export interface IGetResidentsPresencesSuccess {
  type: typeof DAILY_PLAN.GET_RESIDENTS_PRESENCES_SUCCESS;
  payload: {
    startDate: string;
    endDate: string;
    data: any[];
  };
}
export interface IGetResidentsPresencesFailure {
  type: typeof DAILY_PLAN.GET_RESIDENTS_PRESENCES_FAILURE;
  payload: any;
}

export interface IGetResidentPresencesRequest {
  type: typeof DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_REQUEST;
  payload: {
    startDate: string;
    endDate: string;
    residentId: string;
  };
}
export interface IGetResidentPresencesSuccess {
  type: typeof DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_SUCCESS;
  payload: {
    startDate: string;
    endDate: string;
    residentId: string;
    data: any[];
  };
}
export interface IGetResidentPresencesFailure {
  type: typeof DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_FAILURE;
  payload: any;
}

export type PlanActionType =
  | IGetResidentsPresencesRequest
  | IGetResidentsPresencesFailure
  | IGetResidentPresencesRequest
  | IGetResidentPresencesFailure
  | IGetResidentPresencesSuccess
  | IGetResidentsPresencesSuccess
  | IAddPlanConfigRequest
  | IAddPlanConfigSuccess
  | IAddPlanConfigFailure
  | IEditPlanConfigFailure
  | IEditPlanConfigSuccess
  | IEditPlanConfigRequest
  | IDeletePlanConfigFailure
  | IDeletePlanConfigRequest
  | IDeletePlanConfigSuccess
  | IGetResidentsActivitiesSuccess
  | IGetResidentsActivitiesFailure
  | IGetResidentsActivitiesRequest
  | IGetResidentActivitiesSuccess
  | IGetResidentActivitiesFailure
  | IGetResidentActivitiesRequest
  | IGetResidentsConfigurationSuccess
  | IGetResidentsConfigurationRequest
  | IGetResidentsConfigurationFailure
  | ISendResidentActivityRequest
  | ISendResidentActivityFailure
  | ISendResidentActivitySuccess
  | ISkipActivityRequest
  | ISkipActivitySuccess
  | ISkipActivityFailure
  | IGetCongigAddedBySocket
  | IGetCongigDeletedBySocket
  | IGetCongigUpdatedBySocket
  | IGetActivitiesSkipOptionsSuccess
  | IGetActivitiesFeedbackOptionsSuccess
  | IGetActivityBySocket
  | IGetActivitiesFeedbackOptionsFailure;
